import Radium from "radium";
import React from "react";

import { random, formatDate } from "@common";
import { listStyles } from "@common/styles";
import { IDevice } from "@common/models";

export interface IDeviceRowProps {
  device: IDevice;
  approveDevice: (device: IDevice) => void;
  removeDevice: (device: IDevice) => void;
}

class DeviceRow extends React.Component<IDeviceRowProps> {
  public render() {
    const uniqueKey = random();
    const container: any = {
      display: "flex",
      flex: "1",
      justifyContent: "flex-end"
    };

    const { device, removeDevice, approveDevice } = this.props;
    const { isApproved, approvedDate, deviceId, userAgent } = device;

    const approvedMessage = isApproved
      ? `Godkjent: ${formatDate(approvedDate)}`
      : "Ikke godkjent";

    return (
      <div key={uniqueKey} style={{ display: "flex", marginBottom: "10px" }}>
        <div style={{ display: "flex", flex: "1" }}>{userAgent}</div>
        <div style={{ display: "flex", flex: "2" }}>{deviceId}</div>
        <div style={{ display: "flex", flex: "1" }}>{approvedMessage}</div>
        <div style={container}>
          {!isApproved && (
            <div
              key={`approveDevice${uniqueKey}`}
              onClick={() => approveDevice(device)}
              style={listStyles.listLinkStyle}
            >
              Godkjenn
            </div>
          )}
          <div
            key={`removeDevice${uniqueKey}`}
            onClick={() => removeDevice(device)}
            style={listStyles.listLinkStyle}
          >
            Slett
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(DeviceRow);
